<div class="container">
  <app-steps [current]="stepAtual()" [total]="totalSteps()"></app-steps>
  <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center top-16 gap-5">
    <div>
      <h2>Escolha a modalidade do Imposto de Renda</h2>
      <p>
        A escolha da modalidade tributária influencia diretamente o valor líquido do seu resgate. Analise as simulações antes de prosseguir. 
      </p>
    </div>
    <vivest-button variant="outline" size="md" (click)="showModal()">
      <vivest-icon slot="icon-right" name="arrow-right" source="feather"></vivest-icon>
      Veja o comparativo completo 
    </vivest-button>
  </div>
  
  <div class="modalidades d-flex flex-column flex-md-row gap-3" role="radiogroup" aria-label="Modalidade do Imposto de Renda">
    @for (regime of regimes(); track regime.idTipoRegime) {
      <div class="modalidade top-64">
        <!-- Só o cabeçalho com o radio recebe o destaque de selecionado; a descrição fica abaixo, em um card com borda. -->
        <label
          class="modalidade__opcao"
          [class.modalidade__opcao--checked]="regimeSelecionado() === regime.idTipoRegime"
        >
          <input
            class="modalidade__input"
            type="radio"
            name="modalidade-ir"
            [value]="regime.idTipoRegime"
            [checked]="regimeSelecionado() === regime.idTipoRegime"
            [attr.aria-describedby]="'descricao-regime-' + regime.idTipoRegime"
            (change)="regimeSelecionado.set(regime.idTipoRegime)"
          />
          <span class="modalidade__titulo">{{ regime.titulo }}</span>
        </label>
        <dl class="modalidade__descricao" [id]="'descricao-regime-' + regime.idTipoRegime">
          <div class="modalidade__linha">
            <dt>Alíquota efetiva</dt>
            <dd>{{ formatarPercentual(regime.aliquotaEfetiva) }}</dd>
          </div>
          <div class="modalidade__linha">
            <dt>Imposto de renda</dt>
            <dd>{{ formatarMoeda(regime.valorIR) }}</dd>
          </div>
          <div class="modalidade__linha modalidade__valor">
            <dt>Valor líquido</dt>
            <dd class="modalidade__valor-liquido"><span class="moeda">R$</span> {{ formatarValor(regime.valorLiquido) }}</dd>
          </div>
        </dl>
      </div>
    }
  </div>
  
  
  <!-- Só aparece depois que o usuário escolhe um regime, sem pagamento único e se o valor líquido dele não for zero. -->
  @if (exibirParcelas()) {
    <div class="parcelas">
      <h4>Em quantas parcelas deseja receber seu resgate?</h4>
      <vivest-select
        class="parcelas__select"
        label=""
        aria-label="Quantidade de parcelas"
        placeholder="Selecione"
        status="default"
        [options]="parcelaOptions()"
        [value]="parcelaSelecionada()?.toString() ?? ''"
        (change)="onParcelaChange($event)"
      ></vivest-select>
      @if (parcelaSelecionada()) {
        <p class="parcelas__valor">Equivalente a <span class="parcelas__montante"><span class="moeda">R$</span> {{ formatarValor(valorDividido()) }}</span> por mês</p>
      }
    </div>
  }
  <div class="d-flex justify-content-center align-items-center buttons top-64">
    <vivest-button variant="outline" size="md" (click)="onReturn()">
      Voltar
    </vivest-button>
    <vivest-button variant="primary" size="md" [disabled]="!podeContinuar()" (click)="onSubmit()">
      <vivest-icon slot="icon-right" name="arrow-right" source="feather"></vivest-icon>
      Continuar para envio de documentos
    </vivest-button>
  </div>
  
  <vivest-modal
    #modalComparativo
    [hasIcon]="false"
    [open]="openModal()"
    (vivest-close)="closeModal()"
    style="--vivest-modal-width: 868px"
  >
    <div slot="heading"></div>
    <div slot="description">
      <div>
      <div class="close"><button type="button" (click)="closeModal()"><img src="assets/images/icons/x.svg" alt="Fechar"/></button></div>
      <div class="mb-0 text-start">
        <h4 class="modal-title">Regime Progressivo</h4>
        <div class="modal-text top-16">
          <p>Benefício de prestação mensal. Quanto maior a renda, maior o percentual. IR na fonte mensal com ajuste na declaração anual. Como funciona:</p>
          <ul>
            <li>A alíquota do Imposto de Renda (IR) <b>aumenta conforme o valor resgatado</b></li>
            <li>Alíquotas: Vão de <b>0% a 27,5% sendo que no resgate é aplicado 15%</b> a título de adiantamento do valor que será tributado na declaração de ajuste anual.</li>
            <li>Ajuste Anual: A retenção na fonte (15% para resgates) é adiantamento. O valor total será ajustado na sua declaração anual de IR, somando-se a outras rendas e podendo resultar em imposto a pagar ou restituir.</li>
          </ul>
        </div>
        <div class="regressivo">
          <div class="regressivo__coluna">
            <h4 class="modal-title">Regime Regressivo</h4>
            <div class="modal-text top-16">
              <p>Tributação definitiva, por alíquota decrescente conforme o período de acumulação de cada contribuição. IR retido na fonte, sem ajuste na declaração anual.</p>
            </div>
          </div>
          <div class="regressivo__coluna">
            <table class="tabela-ir">
              <thead>
                <tr>
                  <th scope="col">Prazo de acumulação</th>
                  <th scope="col" class="text-right">Percentual de IR</th>
                </tr>
              </thead>
              <tbody>
                @for (aliquota of aliquotasRegressivas; track aliquota.prazo) {
                  <tr>
                    <td>{{ aliquota.prazo }}</td>
                    <td class="text-right">{{ aliquota.percentual }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="top-32">
        <vivest-button slot="actions" variant="outline" size="md" (click)="closeModal()">Fechar</vivest-button>
      </div>
    </div>
    </div>
  </vivest-modal>
</div>
